const handleDeleteDocumentModalDocCompany = {
  confirm: 'Deseja realmente deletar essa entrada?',
  title: 'DELETAR DOCUMENTO'
};

export default handleDeleteDocumentModalDocCompany;
